export default __webpack_public_path__ + "static/media/email.7159c922.svg";